import { collection, onSnapshot, addDoc, doc, setDoc, deleteDoc } from "firebase/firestore";
import { config } from "@/utils/configuration/config";
import { db } from "@/fb.js";
import { getErrorMessageFromFirebaseError } from "@/utils/utils";

export default class ConfigurationRepoFirebase {
  async getConfigurationsForShip(ship, service) {
    // console.log("ConfigurationRepoFirebase-getConfigurationsForShip", ship.id)
    onSnapshot(
      collection(db, config.firebaseConfig.shipsCollectionName, ship.id, "ShipConfigurations"),
      (querySnapshot) => {
        // console.log("ConfigurationRepoFirebase-getConfigurationsForShip")
        const changes = querySnapshot.docChanges();

        changes.forEach(async (change) => {
          console.log("ConfigurationRepoFirebase-getConfigurationsForShip", change.type);

          if (change.type === "added") {
            service.addNewConfigurationFromRepo(ship, change.doc.id, change.doc.data());
          } else if (change.type === "modified") {
            service.modifyConfigurationFromRepo(ship, change.doc.id, change.doc.data());
          } else if (change.type === "removed") {
            service.removeConfigurationFromRepo(ship, change.doc.id);
          }
        });
      }
    );
  }

  createConfiguration(shipId, name, description, isBase) {
    var errors = "";
    try {
      addDoc(collection(db, config.firebaseConfig.shipsCollectionName, shipId, "ShipConfigurations"), {
        name: name,
        description: description,
        attainedEEXI: 0,
        isBase: isBase,
      });
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }
    return errors;
  }

  cloneConfiguration(shipId, configuration, configurationToClone, service) {
    var errors = "";

    try {
      //console.log("Vamos a clonar", configuration);
      addDoc(collection(db, config.firebaseConfig.shipsCollectionName, shipId, "ShipConfigurations"), configuration)
        .then((created) => {
          console.log("creada clonación de configuración", created.id);
          service.clonedConfiguration(shipId, created.id, configuration, configurationToClone);
        })
        .catch((error) => (errors = "" + error));
    } catch (error) {
      console.log("Error en la clonación", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    return errors;
  }

  setConfigurationAsBase(shipId, configurationId, isBase) {
    console.log("Configuration", configurationId, " isBase value " + isBase + " configuration for ship", shipId);

    var errors = "";
    try {
      const configurationRef = doc(
        db,
        config.firebaseConfig.shipsCollectionName,
        shipId,
        "ShipConfigurations",
        configurationId
      );
      setDoc(configurationRef, { isBase: isBase }, { merge: true });
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }
    return errors;
  }

  saveConfiguration(shipId, configuration) {
    var errors = "";
    try {
      const configurationRef = doc(
        db,
        config.firebaseConfig.shipsCollectionName,
        shipId,
        "ShipConfigurations",
        configuration.id
      );
      setDoc(configurationRef, configuration);
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }
    return errors;
  }

  deleteConfiguration(shipId, configurationId) {
    const configurationRef = doc(
      db,
      config.firebaseConfig.shipsCollectionName,
      shipId,
      "ShipConfigurations",
      configurationId
    );
    deleteDoc(configurationRef);
  }
}
